var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"text-center",attrs:{"color":"black","dark":""}},[_c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"pa-10":""}},[_c('small',[_vm._v("© Copyright by Lianber.com")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }